import React from 'react';
import { CircleAlert, CircleCheck } from 'lucide-react';

type SyncHealthProps = {
    discrepancies: number;
};

const SyncHealth = ({ discrepancies }: SyncHealthProps) =>
    discrepancies === 0 ? (
        <span className='inline-flex items-center gap-1 text-sm text-green-100'>
            <CircleCheck className='h-4 w-4' aria-hidden='true' />
            All in sync
        </span>
    ) : (
        <span className='inline-flex items-center gap-1 text-sm text-amber-600'>
            <CircleAlert className='h-4 w-4' aria-hidden='true' />
            Needs attention
        </span>
    );

export default SyncHealth;
